import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !NO_REFRESH.some((p) => cfg.url?.includes(p))) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (_) { /* refresh failed */ }
    }
    return Promise.reject(err);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || JSON.stringify(d)).replace(/^Value error, /, "")).join(" ");
  return detail.msg || String(detail);
}

export async function runJob(path, body) {
  const { data } = await api.post(path, body);
  if (!data?.job_id) return data;
  for (let i = 0; i < 90; i++) {
    await new Promise((r) => setTimeout(r, 2000));
    const job = (await api.get(`/jobs/${data.job_id}`)).data;
    if (job.status === "done") return job.result;
    if (job.status === "error") throw new Error(typeof job.error === "string" ? job.error : "Generation failed. Please try again.");
  }
  throw new Error("Generation is taking longer than expected. Please try again.");
}

export const DIFFICULTIES = ["beginner", "intermediate", "advanced"];

let subjectsCache = null;
export async function fetchSubjects(force = false) {
  if (!subjectsCache || force) subjectsCache = (await api.get("/subjects")).data;
  return subjectsCache;
}
